<template lang="pug">
  page-template
    dashboard(route='recorder' slot='dashboard')

    div(slot='widgets')
      recorder-search-widget
      manual-index(v-if='$loggedIn && $currentLocale === "STATE-IN"' style='margin-top: 0.5rem;')

    div(slot='information')
      div(:class='$style.main_intro')
        img(:class='$style.image' src='@/assets/images/recorder-icon-large.jpg' title='Deed to Statue of Liberty')
        h3 About Doxpop {{ l10n('app.name') }}
        p
          template(v-if='$currentLocale === "STATE-IN"')
            |  Doxpop provides access to over #[strong {{ docCount }}] recorded
            |  documents from #[strong {{ countyCount }}] {{ state }} counties in the
            |  #[app-link(to='/recorderCounties.jsp' target='_blank') Doxpop Network].
          template(v-if='$currentLocale === "STATE-MI"')
            |  Doxpop provides access to over #[strong {{ docCount }}] recorded
            |  documents from Bay and Iosco county {{ l10n('terms.entity') }} office.
          |  Our index information is updated in near real-time with images
          |  updating daily and is accessible 24 hours a day, 7 days a week.
          |  We are working every day to bring new counties to our Recorded
          |  Document Service.

        p(v-if='l10n("features.unlimitedviewing")')
          |  Looking for full-size preview images of documents? Try our
          |  Unlimited Viewing service, available in participating counties.
          |  #[app-link(to='/recorder/UnlimitedViewingSubscription') Click here to learn more].

        p(v-if='$currentLocale !== "STATE-IN"')
          |  Looking for Indiana Recorded Documents? Switch your state in the upper
          |  right-hand corner of the site.
        p(v-if='$currentLocale !== "STATE-MI"')
          |  Looking for Michigan Register of Deeds? Switch your state in the upper
          |  right-hand corner of the site.

      content-box(:class='$style.more_info' color='green' collapsible)
        template(slot='header') More Info

        p
          |  You can use our recorded document search to find documents by
          |  name, indexed details about the document, and even document text.
          |  These documents include deeds, mortgages, and liens (See a more
          |  #[app-link(to='/recorder/document_type_list.jsp') complete list of document types]).
          template(v-if='$loggedIn')
            |  For each document, you will be able to view all details about a document,
            |  and purchase, view, and print pages directly from our website!
          template(v-else)
            |  By #[app-link(to='/common/NewSubscription') subscribing]
            |  to any Doxpop search plan you can access these features, view all
            |  details about a document, and purchase, view, and print pages directly
            |  from our website!

        p(v-if='l10n("features.propertywatch")')
          app-link(to='http://watch.doxpop.com') Doxpop Property Watch
          |  is a free service that helps prevent fraud by notifying people when documents
          |  are filed that affect their property. Early warning when unexpected or
          |  suspicious documents are filed provides property owners with a powerful tool
          |  to stop fraud in the early stages. Doxpop Property Watch sets watches
          |  both on a property owner's name and on properties.
          |  Go to #[app-link(to='http://watch.doxpop.com') watch.doxpop.com]
          |  to set up your notification.

        p
          |  The recorded document information provided through the Doxpop Service
          |  is not the official public record. Our mission is to provide an accurate and
          |  current copy of the official record by maintaining a mirrored copy that is
          |  updated in near real-time. The original, official version of these records
          |  may be obtained by visiting the local {{ l10n('terms.entity') }} Office where
          |  they are maintained.

        p
          |  For user tips and other useful information, check out our
          |  #[app-link(to='/help/HelpTopic') help section].
          template(v-if='$loggedIn')
            |  If you need other assistance in using our services please don't
            |  hesitate to contact our customer support team at {{ supportPhoneNumber }}
            |  where an Indiana based representative will answer the phone!
          template(v-else)
            |  Or to find out what Doxpop customers have to say about the service, take
            |  a look at the
            |  #[app-link(to='/testimonials.jsp') Doxpop Testimonials].
</template>

<script>
import l10n from '@/assets/recorder/l10n'

import AppLink from '@/components/app-link'
import ContentBox from '@/components/content-box'
import Dashboard from '@/components/dashboard'
import ManualIndex from '@/components/recorder/manual-index-search-widget'
import PageTemplate from '@/pages/page-template'
import RecorderSearchWidget from '@/components/recorder/recorder-search-widget'

export default {
  name: 'recorder-tab',
  components: {
    AppLink,
    ContentBox,
    Dashboard,
    ManualIndex,
    PageTemplate,
    RecorderSearchWidget
  },
  head () {
    return {
      title: 'Doxpop ' + l10n(this)('app.name')
    }
  },
  data () {
    return {
      supportPhoneNumber: '866-369-7671',
      state: this.l10n('terms.state')
    }
  },
  created () {
    this.$store.dispatch('app-props/fetch', this)
  },
  computed: {
    docCount () {
      return this.$store.getters['app-props/documentCount']
    },
    countyCount () {
      return this.$store.getters['app-props/recorderCountyCount']
    }
  },
  methods: {
    l10n (key) {
      return l10n(this)(key)
    }
  }
}
</script>

<style lang="scss" module>
.main_intro {
  overflow: auto;
  h3 {
    margin: 0;
  }
}
.more_info {
  margin: 0;
  clear: left
}
.image {
  float: left;
  width: 5.5rem;
  height: 7rem;
  padding-right: 10px;
}
</style>
